// extracted by mini-css-extract-plugin
export default {"table":"dialogReceiveOrder_table__8uyoH"};